import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../services/data.service';
import {SsoService} from './sso.service';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import {LoadingService} from '../../services/loading/loading.service';
import * as Constants from '../../shared/common-components/AppConstants';
import AppConstants from '../../shared/common-components/AppConstants';

@Component({
    selector: 'app-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.css'],
    standalone: false
})
export class SsoComponent implements OnInit {

    public redirectUrl: string;
    private tmssloader;
    userDetails: User | any;
    returnUrl: string;

    /**
     *This component is used after successful login from the SSO
     */
    constructor(private alertService: AlertService, private router: Router, private dataService: DataService,
                private ssoService: SsoService, private activatedRoute: ActivatedRoute,
                private loader: LoadingService, private userService: UserService) {
        // instantiating the loader to the
        this.tmssloader = this.loader;

    }
    ngOnInit() {
        // showing loader
        this.tmssloader.show();
        this.userService.getUserDetails().subscribe(userDetails => {
                console.log('userDetails :', userDetails);
                if (AppConstants.isNotNullCondition(userDetails)) {
                    this.userDetails = userDetails;
                    this.userDetails.isRoleSelected = false;
                    // on we found the user in the database setting user details in the behavioural subject
                    this.userService.setUserObservable(userDetails);
                    localStorage.setItem('currentUser', JSON.stringify(userDetails));
                    // redirecting to the landing page after successful login
                    /*this.redirectUrl = '/landing';*/
                    this.redirectUrl = '/termsAndConditions';
                    if (this.redirectUrl) {
                        // using router navigation to navigate to landing page
                        this.router.navigate([this.redirectUrl]);
                        this.redirectUrl = null;
                    }
                    // this.alertService.success('Successfully Logged In');
                } else {
                    // navigating to home page if user does not found in our database
                    this.router.navigate(['home'], { queryParams: { access: false } });
                    this.alertService.warn('User does not exist, please login through SSO/OKTA');
                }
            },
            (error) => {
                // in case of error showing the error alert from the alert service
                this.alertService.error(Constants.api_error);
                console.log(error);
            }, () => {
                this.tmssloader.hide();
            });



    }

}
